import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Container, Typography } from '@mui/material';
function App() {
    return (_jsxs(Container, { children: [_jsx(Typography, { variant: "h3", component: "h1", children: "Project Frontend" }), _jsx(Button, { variant: "contained", children: "Hello" })] }));
}
export default App;
